import { twMerge } from 'tailwind-merge';

interface MediaHeadingProps {
  title: string;
  icon?: React.ReactNode;
  containerClassName?: string;
  defaultIconClassName?: string;
}

export const MediaHeading = ({
  title,
  icon,
  containerClassName,
  defaultIconClassName,
}: MediaHeadingProps) => {
  return (
    <div
      className={twMerge(
        'flex justify-center gap-1.5 bg-purple-EDECFB/80 p-2 pt-2.5 pb-1',
        containerClassName,
      )}
    >
      {icon || (
        <i
          className={twMerge(
            '-mt-1.5 ki-outline ki-graph-3 text-primary font-bold text-lg shadow-sm max-sm:-mt-2',
            defaultIconClassName,
          )}
        />
      )}
      <div className="text-sm text-primary font-medium leading-tight max-sm:text-xs">
        {title}
      </div>
    </div>
  );
};
